import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MyService } from 'src/app/my.service';
import { AuthService } from '../Services/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent {
  registerData = {

    username: '',
    password: '',
    email:'',
    phoneNumber:'',
    role:'User'

  };

   successMessage = '';
  constructor(private http: HttpClient, private router: Router, private authService:AuthService) {}

  // this.http.post('http://localhost:5000/api/auth/register', this.registerData)

 onSubmit() {
  // اطمینان از اینکه phoneNumber یک رشته است
  this.registerData.phoneNumber = this.registerData.phoneNumber.toString();

  this.authService.register(this.registerData).subscribe({
    next: (response) => {
      // console.log('ثبت‌نام موفقیت‌آمیز:', response);

       // ✅ نمایش پیام موفقیت
        this.successMessage = 'ثبت نام با موفقیت انجام شد';

        // ✅ هدایت پس از تأخیر
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 1500); // 1.5 ثانیه تأخیر برای نمایش پیام

      // this.router.navigate(['/login']);
    },
    error: (error) => {
      console.error('خطا در ثبت‌ نام:', error);
      alert('ثبت‌نام با خطا مواجه شد. لطفاً دوباره تلاش کنید.');
    }
  });
}

}
